import React from 'react';

class EmptyPlayerSlot extends React.Component {
  componentDidMount() {
    if ($('.slots__item-place-user').length) {
        var width = $('.slots__item-place-user').first().width();
        $('.slots__item-place-user').height(width);
    }
  }

  render() {
    return (
        <div className="col-xs-4">
            <div className="slots__item-place-user slots__item-place-user--empty"></div>
        </div>
    );
  }
}

export default EmptyPlayerSlot;
